
define('ldsh!modules/accounts/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="accounts" class="panel panel-default">\n  <div class="panel-body">\n\n    <div class="md__page__title__wrapper">\n      <h1 data-i18n="ACCOUNTS.TITLE" class="i18n"></h1>\n      <span class="ml-5 f13 gris">\n        ' +
((__t = (groupName)) == null ? '' : __t) +
' (' +
((__t = (groupId)) == null ? '' : __t) +
') (' +
((__t = (productIdLabel)) == null ? '' : __t) +
')\n      </span>\n    </div>\n\n    <div class="md__simple__tabs">\n      <ul class="simple__nav__tabs" role="tablist">\n        ';
 if (model.isAdm()) { ;
__p += '\n          <li role="presentation" class="' +
__e(((activeTab === 'status') ? 'active' : '')) +
'">\n            <a href="/accounts/status' +
__e(linkGruopId) +
'" class="i18n" data-i18n="ACCOUNTS.TABS.STATUS"></a>\n          </li>\n          ';
 } ;
__p += '\n            ';
 if (!model.isSuperAdmim()) { ;
__p += '\n              <li role="presentation" class="' +
__e(((activeTab === 'me') ? 'active' : '')) +
'">\n                <a href="/accounts/user/me' +
__e(linkGruopId) +
'" class="i18n" data-i18n="ACCOUNTS.TABS.ME"></a>\n              </li>\n              ';
 } ;
__p += '\n                ';
 if (model.isAdm()) { ;
__p += '\n                  <li role="presentation" class="' +
__e(((activeTab === 'users') ? 'active' : '')) +
'">\n                    <a href="/accounts/users' +
__e(linkGruopId) +
'" class="i18n" data-i18n="ACCOUNTS.TABS.USERS"></a>\n                  </li>\n                  <li role="presentation" class="' +
__e(((activeTab === 'companies') ? 'active' : '')) +
'">\n                    <a href="/accounts/companies' +
__e(linkGruopId) +
'" class="i18n" data-i18n="ACCOUNTS.TABS.COMPANIES"></a>\n                  </li>\n                  ';
 if (allowSecurityOptionsByGroup) { ;
__p += '\n                    <li role="presentation" class="' +
__e(((activeTab === 'security') ? 'active' : '')) +
'">\n                      <a href="/accounts/security' +
__e(linkGruopId) +
'" class="i18n" data-i18n="ACCOUNTS.TABS.SECURITY"></a>\n                    </li>\n                    ';
 } ;
__p += '\n                      ';
 } ;
__p += '\n      </ul>\n    </div>\n\n    <div id="accounts-tab-content" class="tab-content">\n      <div class="spinner__container">\n        <i class="ri-loader-4-fill fa-spin"></i>\n      </div>\n    </div>\n  </div>\n</div>';

}
return __p
};});

